interface ItemMetrics {
    itemEndEdges: number[],
    itemStartEdges: number[],
}

const ITEM_SCROLL_PADDING = 20;

export const calculateItemsEdges = (
    items: HTMLElement[],
    containerRect: DOMRect,
    isVertical = false,
    scrollPadding = ITEM_SCROLL_PADDING,
): ItemMetrics => {
    const itemStartEdges: number[] = [];
    const itemEndEdges: number[] = [];

    items.forEach((item, index) => {
        const itemRect = item.getBoundingClientRect();
        const position = isVertical
            ? itemRect.top - containerRect.top
            : itemRect.left - containerRect.left;
        const size = isVertical ? itemRect.height : itemRect.width;

        const startEdge = index === 0
            ? 0
            : Math.floor(position - scrollPadding);

        const endEdge = Math.ceil(position + size + scrollPadding);

        itemStartEdges.push(startEdge);
        itemEndEdges.push(endEdge);
    });

    return {
        itemEndEdges,
        itemStartEdges,
    };
};
